import { Box, Button, Tooltip } from "@mui/joy";
import Map from "../components/place/map/Map";
import PlaceList from "../components/place/list/PlaceList";
import { useMediaQuery } from "@mui/material";
import HorizontalFilterBar from "../components/place/filter/HorizontalFilterBar";
import { useState, useEffect } from "react";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import MapIcon from "@mui/icons-material/Map";
import { COLOR_BLACK, COLOR_PRIMARY } from "../utils/styles";

function MainLayout() {
  const isMobile = useMediaQuery("(max-width:600px)");

  // Add a state to track if layout has mounted
  const [isMounted, setIsMounted] = useState(false);

  // Set mounted state after component mounts
  useEffect(() => {
    console.log("MainLayout mounted");
    setIsMounted(true);
    return () => {
      console.log("MainLayout unmounting");
      setIsMounted(false);
    };
  }, []);

  const [showList, setShowList] = useState(false); // for mobile only
  const [viewMode, setViewMode] = useState("Split"); // "Split" or "Map"

  // Use isMounted to conditionally render the map to avoid rendering issues
  const renderMap = () => {
    if (!isMounted) {
      return <div style={{ flex: 1, minHeight: "500px" }}>Loading map...</div>;
    }
    return <Map />;
  };

  return (
    <>
      <HorizontalFilterBar viewMode={viewMode} setViewMode={setViewMode} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "100%",
          flex: 1,
          overflow: "hidden",
          minHeight: "500px",
        }}
      >
        {/* List Panel */}
        <Box
          sx={{
            display: "flex",
            width: "480px",
            flexShrink: 0,
            overflow: "auto",
            maxHeight: "100%",
            transform: (viewMode === "Split" || (isMobile && showList))
              ? "translateX(0)"
              : "translateX(-100%)",
            transition: "transform 0.3s ease-in-out",
            position: "absolute",
            height: "100%",
            zIndex: 2,
            backgroundColor: "white",
          }}
        >
          <PlaceList />
        </Box>

        {/* Map Panel */}
        <Box
          sx={{
            display: "flex",
            flex: 1,
            height: "100%",
            minHeight: "500px",
            transition: "all 0.3s ease-in-out",
            marginLeft: (viewMode === "Split" || (isMobile && showList)) ? "480px" : 0,
          }}
        >
          {renderMap()}
        </Box>
      </Box>

      {/* Mobile Toggle Button */}
      {isMobile && (
        <Tooltip title={showList ? "Show Map" : "Show List"}>
          <Button
            sx={{
              position: "fixed",
              bottom: 25,
              right: "calc(50% - 24px)",
              backgroundColor: COLOR_BLACK,
              "&:hover": {
                backgroundColor: COLOR_PRIMARY,
              },
              zIndex: 1000,
            }}
            onClick={() => setShowList(!showList)}
          >
            {showList ? <MapIcon /> : <FormatListBulletedIcon />}
          </Button>
        </Tooltip>
      )}
    </>
  );
}

export default MainLayout;
